import React from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap"
function Privacy() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs title="Hom" breadcrumbItem="Privacy Policy" /> */}
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <div>
                        <h5 className="text-center mb-5">Privacy Policy</h5>
                        <p>
                          At Jain International Network ("JIN" or "App"), we
                          respect your privacy and are committed to protecting
                          your personal data. This Privacy Policy explains how
                          we collect, use, and protect your personal data when
                          you use our App.
                        </p>

                        <div className="mt-3">
                          <p>
                            <b>1. Collection of Personal Data</b>
                          </p>
                          <div>
                            <p>
                              We collect personal data that you provide to us
                              when you:
                            </p>
                            <ul>
                              <li>Create an account on the App</li>
                              <li>Fill out a profile or registration form</li>
                              <li>Post or upload content to the App</li>
                              <li>Contact us with a question or request</li>
                            </ul>
                          </div>

                          <div>
                            <p>The personal data we collect may include:</p>
                            <ul>
                              <li>
                                Your name and contact information (email
                                address, phone number)
                              </li>
                              <li>
                                Your profile information (username, bio, profile
                                picture)
                              </li>
                              <li>Your location (city, country)</li>
                              <li>Any other information you choose to provide to us</li>
                            </ul>
                          </div>
                        </div>

                        <div className="mt-3">
                          <p>
                            <b>2. Use of Personal Data</b>
                          </p>
                          <div>
                            <p>
                            We use your personal data for the following purposes:
                            </p>
                            <ul>
                              <li>To provide you with access to the App and its features</li>
                              <li>To personalize your experience on the App</li>
                              <li>To personalize your experience on the App</li>
                              <li>To respond to your questions and requests</li>
                              <li>To improve the App and its features</li>
                            </ul>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p>
                            <b>3. Protection of Personal Data</b>
                          </p>
                          <div>
                            <p>
                            We take reasonable measures to protect your personal data from unauthorized access, use, or disclosure. These measures include:
                            </p>
                            <ul>
                              <li>Encrypting your personal data when it is transmitted to us</li>
                              <li>Storing your personal data on secure servers</li>
                              <li>Storing your personal data on secure servers</li>
                            </ul>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p>
                            <b>4. Sharing of Personal Data</b>
                          </p>
                          <div>
                            <p>
                            We may share your personal data with third-party service providers who help us operate the App and provide its features. These service providers may include:
                            </p>
                            <ul>
                              <li>Cloud storage providers</li>
                              <li>Analytics providers</li>
                              <li>Customer support providers</li>
                            </ul>
                            <p>We may also share your personal data with law enforcement or other government agencies if required by law.                            </p>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p>
                            <b>5. Your Rights</b>
                          </p>
                          <div>
                            <p>
                            You have the right to: </p>
                            <ul>
                              <li>Access your personal data</li>
                              <li>Correct or update your personal data</li>
                              <li>Delete your personal data</li>
                              <li>Opt-out of receiving communications from us</li>
                            </ul>
                            <p>To exercise these rights, please contact us at [jaininternationalnetwork@gmail.com]</p>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p>
                            <b>6. Changes to Privacy Policy</b>
                          </p>
                          <div>
                            <p>We may update this Privacy Policy from time to time. If we make significant changes to this Privacy Policy, we will notify you by email or through a notice on the App.
                            By using the App, you acknowledge that you have read and understood this Privacy Policy. </p>
                          </div>
                        </div>

                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Privacy
